module.exports = __webpack_public_path__ + "img/symbol_6.a6e0425f.png";